export const feedbackAnalyticsApi = (client) => ({
    summary: (params) => client.get('/api/v1/feedback-analytics/summary', { params }).then((r) => r.data),
    trend: (params) => client.get('/api/v1/feedback-analytics/trend', { params }).then((r) => r.data),
});
//# sourceMappingURL=feedback-analytics.js.map